import React from "react";
import { Grid, Typography, TextField, Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import CounterMeasures from "./CounterMeasures";

const FiveWhysAnalysis = (props) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const inputStyle = {
        fontSize: "12px", // Adjust the font size as needed
    };
    return (
        <Grid item xs={12} sm={7} md={7}>
            <Box
                sx={{
                    width: "98%",
                    px: 1,
                    py: 1,
                    m: 1,
                    mt: 0,
                    alignItems: "center",
                    backgroundColor: theme.palette.grey[100],
                    borderRadius: "12px",
                    boxShadow: 3,
                    gap: 2
                }}
            >
                <Grid item xs={12} sm={12} md={12}>
                    <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold", backgroundColor: "#DEE0E0" }}>
                        {t("5WHYSAnalysis")}
                    </Typography>
                </Grid>
                {/* 1st WHY */}
                <Grid container xs={12} sm={12}>
                    <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center", marginTop: "20px" }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 12, fontWeight: "bold" }}>
                            {t("1stWhy")}
                        </Typography>
                    </Grid>
                    <Grid item xs={11 / 4} sm={11 / 4} sx={{ display: "grid", padding: 0.5 }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 10, fontWeight: "bold" }}>
                            {t("Hypothesis1")}
                        </Typography>
                        <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                            <TextField
                                size="small"
                                type="primary"
                                rows={2}
                                multiline
                                disabled={props.disableStates.isHypothesis1_1Disable}
                                value={props.hypothesis1_1 || null}
                                InputProps={{ style: inputStyle }}
                                onChange={props.handleHypothesis1_1Change}
                                fullWidth
                                error={props.hasHypothesis1_1Error}
                                helperText={props.hypothesis1_1ErrorText}
                            ></TextField>
                        </Typography>
                    </Grid>
                    <Grid item xs={11 / 4} sm={11 / 4} sx={{ display: "grid", padding: 0.5 }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 10, fontWeight: "bold" }}>
                            {t("Hypothesis2")}
                        </Typography>
                        <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                            <TextField
                                size="small"
                                type="primary"
                                rows={2}
                                multiline
                                disabled={props.disableStates.isHypothesis1_2Disable}
                                value={props.hypothesis1_2 || null}
                                InputProps={{ style: inputStyle }}
                                onChange={(e) => props.setHypothesis1_2(e.target.value)}
                                fullWidth
                            ></TextField>
                        </Typography>
                    </Grid>
                    <Grid item xs={11 / 4} sm={11 / 4} sx={{ display: "grid", padding: 0.5 }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 10, fontWeight: "bold" }}>
                            {t("Hypothesis3")}
                        </Typography>
                        <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                            <TextField
                                size="small"
                                type="primary"
                                rows={2}
                                multiline
                                disabled={props.disableStates.isHypothesis1_3Disable}
                                value={props.hypothesis1_3 || null}
                                InputProps={{ style: inputStyle }}
                                onChange={(e) => props.setHypothesis1_3(e.target.value)}
                                fullWidth
                            ></TextField>
                        </Typography>
                    </Grid>
                    <Grid item xs={11 / 4} sm={11 / 4} sx={{ display: "grid", padding: 0.5 }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 10, fontWeight: "bold" }}>
                            {t("Hypothesis4")}
                        </Typography>
                        <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                            <TextField
                                size="small"
                                type="primary"
                                rows={2}
                                multiline
                                disabled={props.disableStates.isHypothesis1_4Disable}
                                value={props.hypothesis1_4 || null}
                                InputProps={{ style: inputStyle }}
                                onChange={(e) => props.setHypothesis1_4(e.target.value)}
                                fullWidth
                            ></TextField>
                        </Typography>
                    </Grid>
                </Grid>
                {/* 2nd WHY */}
                <Grid container xs={12} sm={12}>
                    <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 12, fontWeight: "bold" }}>
                            {t("2ndWhy")}
                        </Typography>
                    </Grid>
                    <Grid item xs={11 / 4} sm={11 / 4} sx={{ display: "grid", padding: 0.5 }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                            <TextField
                                size="small"
                                type="primary"
                                rows={2}
                                multiline
                                disabled={props.disableStates.isHypothesis2_1Disable}
                                value={props.hypothesis2_1 || null}
                                InputProps={{ style: inputStyle }}
                                onChange={(e) => props.setHypothesis2_1(e.target.value)}
                                fullWidth
                            ></TextField>
                        </Typography>
                    </Grid>
                    <Grid item xs={11 / 4} sm={11 / 4} sx={{ display: "grid", padding: 0.5 }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                            <TextField
                                size="small"
                                type="primary"
                                rows={2}
                                multiline
                                disabled={props.disableStates.isHypothesis2_2Disable}
                                value={props.hypothesis2_2 || null}
                                InputProps={{ style: inputStyle }}
                                onChange={(e) => props.setHypothesis2_2(e.target.value)}
                                fullWidth
                            ></TextField>
                        </Typography>
                    </Grid>
                    <Grid item xs={11 / 4} sm={11 / 4} sx={{ display: "grid", padding: 0.5 }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                            <TextField
                                size="small"
                                type="primary"
                                rows={2}
                                multiline
                                disabled={props.disableStates.isHypothesis2_3Disable}
                                value={props.hypothesis2_3 || null}
                                InputProps={{ style: inputStyle }}
                                onChange={(e) => props.setHypothesis2_3(e.target.value)}
                                fullWidth
                            ></TextField>
                        </Typography>
                    </Grid>
                    <Grid item xs={11 / 4} sm={11 / 4} sx={{ display: "grid", padding: 0.5 }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                            <TextField
                                size="small"
                                type="primary"
                                rows={2}
                                multiline
                                disabled={props.disableStates.isHypothesis2_4Disable}
                                value={props.hypothesis2_4 || null}
                                InputProps={{ style: inputStyle }}
                                onChange={(e) => props.setHypothesis2_4(e.target.value)}
                                fullWidth
                            ></TextField>
                        </Typography>
                    </Grid>
                </Grid>
                {/* 3rd WHY */}
                <Grid container xs={12} sm={12}>
                    <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 12, fontWeight: "bold" }}>
                            {t("3rdWhy")}
                        </Typography>
                    </Grid>
                    <Grid item xs={11 / 4} sm={11 / 4} sx={{ display: "grid", padding: 0.5 }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                            <TextField
                                size="small"
                                type="primary"
                                rows={2}
                                multiline
                                disabled={props.disableStates.isHypothesis3_1Disable}
                                value={props.hypothesis3_1 || null}
                                InputProps={{ style: inputStyle }}
                                onChange={(e) => props.setHypothesis3_1(e.target.value)}
                                fullWidth
                            ></TextField>
                        </Typography>
                    </Grid>
                    <Grid item xs={11 / 4} sm={11 / 4} sx={{ display: "grid", padding: 0.5 }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                            <TextField
                                size="small"
                                type="primary"
                                rows={2}
                                multiline
                                disabled={props.disableStates.isHypothesis3_2Disable}
                                value={props.hypothesis3_2 || null}
                                InputProps={{ style: inputStyle }}
                                onChange={(e) => props.setHypothesis3_2(e.target.value)}
                                fullWidth
                            ></TextField>
                        </Typography>
                    </Grid>
                    <Grid item xs={11 / 4} sm={11 / 4} sx={{ display: "grid", padding: 0.5 }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                            <TextField
                                size="small"
                                type="primary"
                                rows={2}
                                multiline
                                disabled={props.disableStates.isHypothesis3_3Disable}
                                value={props.hypothesis3_3 || null}
                                InputProps={{ style: inputStyle }}
                                onChange={(e) => props.setHypothesis3_3(e.target.value)}
                                fullWidth
                            ></TextField>
                        </Typography>
                    </Grid>
                    <Grid item xs={11 / 4} sm={11 / 4} sx={{ display: "grid", padding: 0.5 }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                            <TextField
                                size="small"
                                type="primary"
                                rows={2}
                                multiline
                                disabled={props.disableStates.isHypothesis3_4Disable}
                                value={props.hypothesis3_4 || null}
                                InputProps={{ style: inputStyle }}
                                onChange={(e) => props.setHypothesis3_4(e.target.value)}
                                fullWidth
                            ></TextField>
                        </Typography>
                    </Grid>
                </Grid>
                {/* 4th WHY */}
                <Grid container xs={12} sm={12}>
                    <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 12, fontWeight: "bold" }}>
                            {t("4thWhy")}
                        </Typography>
                    </Grid>
                    <Grid item xs={11 / 4} sm={11 / 4} sx={{ display: "grid", padding: 0.5 }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                            <TextField
                                size="small"
                                type="primary"
                                rows={2}
                                multiline
                                disabled={props.disableStates.isHypothesis4_1Disable}
                                value={props.hypothesis4_1 || null}
                                InputProps={{ style: inputStyle }}
                                onChange={(e) => props.setHypothesis4_1(e.target.value)}
                                fullWidth
                            ></TextField>
                        </Typography>
                    </Grid>
                    <Grid item xs={11 / 4} sm={11 / 4} sx={{ display: "grid", padding: 0.5 }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                            <TextField
                                size="small"
                                type="primary"
                                rows={2}
                                multiline
                                disabled={props.disableStates.isHypothesis4_2Disable}
                                value={props.hypothesis4_2 || null}
                                InputProps={{ style: inputStyle }}
                                onChange={(e) => props.setHypothesis4_2(e.target.value)}
                                fullWidth
                            ></TextField>
                        </Typography>
                    </Grid>
                    <Grid item xs={11 / 4} sm={11 / 4} sx={{ display: "grid", padding: 0.5 }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                            <TextField
                                size="small"
                                type="primary"
                                rows={2}
                                multiline
                                disabled={props.disableStates.isHypothesis4_3Disable}
                                value={props.hypothesis4_3 || null}
                                InputProps={{ style: inputStyle }}
                                onChange={(e) => props.setHypothesis4_3(e.target.value)}
                                fullWidth
                            ></TextField>
                        </Typography>
                    </Grid>
                    <Grid item xs={11 / 4} sm={11 / 4} sx={{ display: "grid", padding: 0.5 }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                            <TextField
                                size="small"
                                type="primary"
                                rows={2}
                                multiline
                                disabled={props.disableStates.isHypothesis4_4Disable}
                                value={props.hypothesis4_4 || null}
                                InputProps={{ style: inputStyle }}
                                onChange={(e) => props.setHypothesis4_4(e.target.value)}
                                fullWidth
                            ></TextField>
                        </Typography>
                    </Grid>
                </Grid>
                {/* 5th WHY */}
                <Grid container xs={12} sm={12}>
                    <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 12, fontWeight: "bold" }}>
                            {t("5thWhy")}
                        </Typography>
                    </Grid>
                    <Grid item xs={11 / 4} sm={11 / 4} sx={{ display: "grid", padding: 0.5 }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                            <TextField
                                size="small"
                                type="primary"
                                rows={2}
                                multiline
                                disabled={props.disableStates.isHypothesis5_1Disable}
                                value={props.hypothesis5_1 || null}
                                InputProps={{ style: inputStyle }}
                                onChange={(e) => props.setHypothesis5_1(e.target.value)}
                                fullWidth
                            ></TextField>
                        </Typography>
                    </Grid>
                    <Grid item xs={11 / 4} sm={11 / 4} sx={{ display: "grid", padding: 0.5 }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                            <TextField
                                size="small"
                                type="primary"
                                rows={2}
                                multiline
                                disabled={props.disableStates.isHypothesis5_2Disable}
                                value={props.hypothesis5_2 || null}
                                InputProps={{ style: inputStyle }}
                                onChange={(e) => props.setHypothesis5_2(e.target.value)}
                                fullWidth
                            ></TextField>
                        </Typography>
                    </Grid>
                    <Grid item xs={11 / 4} sm={11 / 4} sx={{ display: "grid", padding: 0.5 }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                            <TextField
                                size="small"
                                type="primary"
                                rows={2}
                                multiline
                                disabled={props.disableStates.isHypothesis5_3Disable}
                                value={props.hypothesis5_3 || null}
                                InputProps={{ style: inputStyle }}
                                onChange={(e) => props.setHypothesis5_3(e.target.value)}
                                fullWidth
                            ></TextField>
                        </Typography>
                    </Grid>
                    <Grid item xs={11 / 4} sm={11 / 4} sx={{ display: "grid", padding: 0.5 }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                            <TextField
                                size="small"
                                type="primary"
                                rows={2}
                                multiline
                                disabled={props.disableStates.isHypothesis5_4Disable}
                                value={props.hypothesis5_4 || null}
                                InputProps={{ style: inputStyle }}
                                onChange={(e) => props.setHypothesis5_4(e.target.value)}
                                fullWidth
                            ></TextField>
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
            <Box
                sx={{
                    width: "98%",
                    px: 1,
                    py: 1,
                    m: 1,
                    mt: 0,
                    alignItems: "center",
                    backgroundColor: theme.palette.grey[100],
                    borderRadius: "12px",
                    boxShadow: 3,
                    gap: 2
                }}
            >
                {/*COUNTERMEASURES*/}
                <CounterMeasures
                    inputStyle={inputStyle}
                    disableStates={props.disableStates}
                    a1What={props.a1What}
                    setA1What={props.setA1What}
                    a1Who={props.a1Who}
                    setA1Who={props.setA1Who}
                    a1When={props.a1When}
                    setA1When={props.setA1When}
                    a2What={props.a2What}
                    setA2What={props.setA2What}
                    a2Who={props.a2Who}
                    setA2Who={props.setA2Who}
                    a2When={props.a2When}
                    setA2When={props.setA2When}
                    a3What={props.a3What}
                    setA3What={props.setA3What}
                    a3Who={props.a3Who}
                    setA3Who={props.setA3Who}
                    a3When={props.a3When}
                    setA3When={props.setA3When}
                    a4What={props.a4What}
                    setA4What={props.setA41What}
                    a4Who={props.a4Who}
                    setA4Who={props.setA4Who}
                    a4When={props.a4When}
                    setA4When={props.setA4When}
                    amWhat={props.amWhat}
                    setAmWhat={props.setAmWhat}
                    amWho={props.amWho}
                    setAmWho={props.setAmWho}
                    amWhen={props.amWhen}
                    setAmWhen={props.setAmWhen}
                    ftWhat={props.ftWhat}
                    setFtWhat={props.setFt1What}
                    ftWho={props.ftWho}
                    setFtWho={props.setFtWho}
                    ftWhen={props.ftWhen}
                    setFtWhen={props.setFtWhen}
                    smWhat={props.smWhat}
                    setSmWhat={props.setSmWhat}
                    smWho={props.smWho}
                    setSmWho={props.setSmWho}
                    smWhen={props.smWhen}
                    setSmWhen={props.setSmWhen}
                    pmWhat={props.pmWhat}
                    setPmWhat={props.setPmWhat}
                    pmWho={props.pmWho}
                    setPmWho={props.setPmWho}
                    pmWhen={props.pmWhen}
                    setPmWhen={props.setPmWhen}
                    drWhat={props.drWhat}
                    setDrWhat={props.setDrWhat}
                    drWho={props.drWho}
                    setDrWho={props.setDrWho}
                    drWhen={props.drWhen}
                    setDrWhen={props.setDrWhen}
                    asWhat={props.asWhat}
                    setAsWhat={props.setAsWhat}
                    asWho={props.asWho}
                    setAsWho={props.setAsWho}
                    asWhen={props.asWhen}
                    setAsWhen={props.setAsWhen}
                    plWhat={props.plWhat}
                    setPlWhat={props.setPlWhat}
                    plWho={props.plWho}
                    setPlWho={props.setPlWho}
                    plWhen={props.plWhen}
                    setPlWhen={props.setPlWhen}
                />
            </Box>
        </Grid>
    );
};

export default FiveWhysAnalysis;
